export const ONE_COL_LAYOUT_THRESHOLD_PX = 1200;
export const FETCH_NEXT_CONFS_BATCH_THRESHOLD_PX = 400;

export enum DATE_RANGE_TYPE {
    FOR_3_MONTH = 'for-3-month',
    SPECIFIC_MONTH = 'specific-month',
    SPECIFIC_DATES = 'specific-dates',
    SPECIFIC_DATE = 'specific-date',
}

export enum ARTIFACTS_FILTER_OPTION {
    ALL_CONFS = 'all-confs',
    WITH_RECORDING = 'with-recording',
    WITH_SUMMARY = 'with-summary',
    WITH_REPORT = 'with-report',
    NO_ARTIFACTS = 'no-artifacts',
}

export const CONFERENCE_HISTORY_PAGE_ID = 'conference-history-page';
